import React from "react";
import "./VSL.css";

const VSL = () => {
  return (
    <section className="hermes-section" id="vsl">
      <div className="hermes-container">
        <div className="hermes-grid" data-aos="fade-up">
          <div className="hermes-video-wrapper">
            <div className="video-container">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/bQ0TdjukLQ8?autoplay=1&mute=1&loop=1&playlist=bQ0TdjukLQ8"
                title="VSL Hermes"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div className="hermes-text">
            <h2 className="hermes-title">
              Na mitologia grega, Hermes era o mensageiro dos deuses.
            </h2>
            <p className="hermes-paragraph">
              Mas ele não era apenas um entregador de recados.
            </p>
            <p className="hermes-paragraph">
              Era quem sabia <strong>onde, como e quando</strong> a mensagem
              precisava chegar.
            </p>
            <p className="hermes-paragraph">
              Era <strong>estratégia</strong>. <strong>Precisão</strong>.{" "}
              <strong>Velocidade</strong>. <strong>Resultado</strong>.
            </p>
            <p className="hermes-paragraph">
              Hoje, o que falta a muitos consultórios não é{" "}
              <strong>competência técnica</strong>.<br />É{" "}
              <span className="highlight">inteligência comercial</span>.
            </p>
            <p className="hermes-paragraph">
              A mensagem certa está sendo enviada…
              <br />
              Mas <em>da maneira errada</em>.<br />
              <em>No tempo errado</em>.<br />
              <em>Para a pessoa errada</em>.
            </p>
            <p className="hermes-paragraph final">E isso custa caro.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VSL;
